import React, { useMemo } from 'react';
import DatePicker, { registerLocale } from "react-datepicker";
import ru from 'date-fns/locale/ru';
import { parse, format, isValid } from 'date-fns';

import "react-datepicker/dist/react-datepicker.css";
import styles from '../../../styles/components/Modal/Filter/DateSelector.module.css';

registerLocale('ru', ru);

export const DateSelector = ({ filterName, selectedValue, handleFilterChange, theme }) => {
    
    const dateValue = useMemo(() => {
        if (!selectedValue) return null;
        const parsed = parse(selectedValue, 'dd-MM-yyyy', new Date());
        return isValid(parsed) ? parsed : null;
    }, [selectedValue]);

    const handleChange = (date) => {
        if (date && isValid(date)) {
            const formattedDate = format(date, 'dd-MM-yyyy');
            handleFilterChange(filterName, formattedDate);
        } else {
            handleFilterChange(filterName, '');
        }
    };

    return (
        <div className={`${styles.selectContainer} ${theme === 'dark' ? styles.darkTheme : ''}`}>
            <DatePicker
                selected={dateValue}
                onChange={handleChange}
                dateFormat="dd-MM-yyyy"
                locale="ru"
                isClearable
                placeholderText="дд-мм-гггг"
                autoComplete="off"
                className={styles.selectField}
                calendarClassName={styles.customCalendar} 
                popperPlacement="bottom-start"
                popperStrategy="fixed"
            />
        </div>
    );
};